module.exports = __webpack_public_path__ + "img/main_section_img1.1b1dfdb0.png";